import { DragEvent, RefObject, useCallback } from 'react';

const SCROLL_STEP = 10;
const HEIGHT_PERCENT_THRESHOLD = 0.1;

export const useScrollWhenDragging = (ref: RefObject<HTMLDivElement>) => {
    return useCallback(
        (e: DragEvent<HTMLDivElement>) => {
            const container = ref.current;
            if (!container) return;

            const rect = container.getBoundingClientRect();

            const threshold = HEIGHT_PERCENT_THRESHOLD * rect.height;
            const scrollStep = SCROLL_STEP;

            if (e.clientY < threshold + rect.top) {
                container.scrollTop -= scrollStep;
            } else if (e.clientY > rect.bottom - threshold) {
                container.scrollTop += scrollStep;
            }
        },
        [ref],
    );
};
